module.exports = __webpack_public_path__ + "img/screenBackNameHover.d0191f2c.png";